// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import './common/style/index.scss'
import Icon from './common/vue/icon'
import i18n from './lang/lang'
import MintUI from 'mint-ui'
import 'mint-ui/lib/style.css'
import locale from 'element-ui/lib/locale/lang/en'
import store from './store/store';

Vue.config.productionTip = false

Vue.use(ElementUI, { locale })
Vue.use(MintUI)
Vue.component('icon', Icon)

import Screen from './common/vue/screen';

Vue.component('screen', Screen);

import api from './api/api'

Vue.prototype.$api = api;

import unit from './common/js/unit';

Vue.prototype.$unit = unit;

import HandelArray from './common/js/handelArray';
Vue.prototype.$array = HandelArray;

import LocalConfig from './common/js/getConfig';
Vue.prototype.$config = LocalConfig;

i18n.locale = localStorage.getItem('lang') ? localStorage.getItem('lang') : 'en';

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  i18n,
  template: '<App/>',
  components: {App}
});



// WEBPACK FOOTER //
// ./src/main.js